export const LABEL_TITLE = 'Title';
export const LABEL_DESCRIPTION = 'Description';
export const LABEL_CAUSE = 'Cause';
export const LABEL_EFFECT = 'Effect';
export const LABEL_AFFECTED_ENTITIES = 'Affected Entities';
